import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { stringify } from 'query-string';
import ReactIframeResizer from 'react-iframe-resizer-super';
import _get from 'lodash/get';

export const SegmentTypes = {
  PAX: 1,
  DAX: 2,
  MEX: 3,
};

export const parseTabConfig = tabConfig => {
  const tabLabels = [];
  const tabCharts = {};

  for (let i = 0; i < tabConfig.length; i += 1) {
    const { name, charts } = tabConfig[i];
    tabLabels.push(name);
    tabCharts[`tab_${name}`] = charts;
  }

  return { tabLabels, ...tabCharts };
};

export const getWidgetID = segmentIdentity =>
  `SegPInsights-${segmentIdentity}.${Date.now()}`;

class SegPInsights extends PureComponent {
  static propTypes = {
    src: PropTypes.string.isRequired,
    segmentIdentity: PropTypes.string.isRequired,
    segmentType: PropTypes.number,
    namespace: PropTypes.string.isRequired,
    segmentSize: PropTypes.number.isRequired,
    tabConfig: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string.isRequired,
        charts: PropTypes.arrayOf(PropTypes.string),
      }),
    ),
    token: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    tabConfig: [],
    segmentType: SegmentTypes.PAX,
    token: null,
    onChange: null,
  };

  state = {
    widgetID: null,
  };

  componentDidMount() {
    window.addEventListener('message', this.handleMessage);
  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage);
  }

  formatParams = () => {
    const {
      src,
      segmentIdentity,
      segmentType,
      namespace,
      segmentSize,
      tabConfig,
      token,
    } = this.props;

    let widgetID = this.state.widgetID;
    if (!widgetID) {
      widgetID = getWidgetID(segmentIdentity);
      this.setState({ widgetID });
    }

    const stringifiedParams = stringify(
      {
        segmentIdentity,
        segmentType,
        namespace,
        segmentSize,
        token,
        widgetID,
        ...parseTabConfig(tabConfig),
      },
      {
        arrayFormat: 'comma',
      },
    );

    return `${src}?${stringifiedParams}`;
  };

  handleMessage = event => {
    const { segmentIdentity, segmentType, namespace, onChange } = this.props;

    const type = _get(event, 'data.type', '');
    const eventWidgetID = _get(event, 'data.widgetID', '');

    if (eventWidgetID !== this.state.widgetID) return;

    if (type === 'onChange' && onChange) {
      const data = _get(event, 'data.data', null);
      onChange({
        request: {
          segmentIdentity,
          segmentType,
          namespace,
        },
        data,
      });
    }
  };

  render() {
    return (
      <ReactIframeResizer
        title="SegP Insights"
        frameBorder={0}
        style={{ width: '100%' }}
        iframeResizerOptions={{
          heightCalculationMethod: 'taggedElement',
          checkOrigin: false,
        }}
        src={this.formatParams()}
      />
    );
  }
}

export default SegPInsights;
